import React from "react";
import { put } from "../../utils/api";
import GenericViewDrawer1 from "./GenericViewDrawer1";

const ViewDetailsDrawerEquipment = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    {
      label: "Consumption Month",
      previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
      requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
        data?.editValue?.consumptionPeriod?.year || "—"
      }`,
    },
    {
      label: "Equipment",
      previous: data?.equipment?.equipment || data?.equipment?.name || "—",
      requested: data?.editValue?.equipmentData?.equipment || "—",
    },
    {
      label: "Brand",
      previous: data?.brand,
      requested: data?.editValue?.brand,
    },
    {
      label: "Model",
      previous: data?.model,
      requested: data?.editValue?.model,
    },
    {
      label: "Unit Consumption",
      previous: data?.unitConsumption || data?.unitOfConsumption,
      requested:
        data?.editValue?.unitConsumption || data?.editValue?.unitOfConsumption,
    },
    {
      label: "Used Hours",
      previous: data?.usedHours,
      requested: data?.editValue?.usedHours,
    },
    {
      label: "Remark",
      previous: data?.remarks,
      requested: data?.editValue?.remarks,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Electricity Equipment Consumption Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerEquipment;
